import { activeFamilyOf, familyArrayKey } from '../encounter/encounterStoreEngine';

// One adapter from the existing Combat PRO encounter/player runtime references
// to the Authority 02 canonical backend context. Sharing, spells, inventory and
// later integration surfaces reuse this; it does not own identity state.
export function runtimeContextPayload(state) {
  const store = state.encounterStore || {};
  const index = typeof store.activeIndex === 'number' ? store.activeIndex : 0;
  const family = activeFamilyOf(store);
  const familyKey = familyArrayKey(family);
  const encounters = Array.isArray(store[familyKey]) ? store[familyKey] : [];
  const encounter = encounters[index] || {};
  const meta = encounter.meta || {};
  return {
    campaign_ref: 'combat-pro-default',
    campaign_name: meta.campaign || 'Combat PRO Campaign',
    encounter_ref: family + ':' + index,
    encounter_name: meta.name || ('Encounter ' + (index + 1)),
    players: (state.players || []).filter(function (player) { return !player.companion; }).map(function (player) {
      return { runtime_ref: String(player.id), display_name: player.name };
    }),
  };
}
